import React from "react";
import classes from "./ReadOnlyWebHUD.module.css";
import { motion } from "framer-motion";

const ReadOnlyWebHUD = ({ dateId, stats, question }) => {
  return (
    <motion.div
      className={classes.hud}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {/* --- Header --- */}
      <div className={classes.header}>
        <h2 className={classes.title}>🌐 Daily Web</h2>
        <p className={classes.date}>{dateId}</p>
      </div>

      {question && (
        <div className={classes.questionBox}>
          <p className={classes.questionText}>{question}</p>
        </div>
      )}

      {/* --- Stats Summary --- */}
      <div className={classes.stats}>
        <span className={classes.statItem}>
          <strong>{stats?.nodes || 0}</strong> Nodes
        </span>
      </div>

      {/* --- Controls Section --- */}
      <h3 className={classes.subtitle}>Controls</h3>
      <ul className={classes.list}>
        <li>
          <span className={classes.key}>🖐️</span> <strong>Pan:</strong> Two-finger drag
        </li>
        <li>
          <span className={classes.key}>🔍</span> <strong>Zoom:</strong> Pinch or scroll
        </li>
        <li>
          <span className={classes.key}>☝️</span> <strong>Rotate:</strong> One-finger drag
        </li>
      </ul>
    </motion.div>
  );
};

export default ReadOnlyWebHUD;
